/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcedureTransactionDetailsViewModel } from './procedureTransactionDetailsViewModel';
import { ProcedureSimpleViewModel } from './procedureSimpleViewModel';
import { LocationDetailsViewModel } from './locationDetailsViewModel';
import { EobHistoryViewModel } from './eobHistoryViewModel';
import { FinancialClassViewModel } from './financialClassViewModel';
import { CodeSimpleViewModel } from './codeSimpleViewModel';
import { CodeViewModel } from './codeViewModel';
import { InsuranceDetailsViewModel } from './insuranceDetailsViewModel';
import { PendingBatchTransactionViewModel } from './pendingBatchTransactionViewModel';
import { ProviderViewModel } from './providerViewModel';
import { ARTransactionDetailsViewModel } from './aRTransactionDetailsViewModel';

export interface VisitDetailsViewModel {
  id?: string;
  datasetId?: string;
  patientId?: string;
  financialClassId?: string;
  isMerged?: boolean;
  referenceNumber?: number | null;
  adjusted?: number;
  adjusted2?: number;
  balance?: number;
  patientBalance?: number;
  insuranceBalance?: number;
  paid?: number;
  holdStatus?: string | null;
  delinquencyCode?: number;
  inCollectionModule?: boolean;
  isScheduledWriteoff?: boolean;
  accidentTypeId?: string | null;
  accidentType?: CodeViewModel;
  daysAged?: number;
  hospitalAdmitDate?: string | null;
  hospitalDischargeDate?: string | null;
  illnessInjuryDate?: string | null;
  accidentStateCode?: string | null;
  latestProcedureTransaction?: string | null;
  procedureAmount?: number;
  procedureCount?: number;
  paymentCount?: number;
  adjustmentCount?: number;
  financialClass?: FinancialClassViewModel;
  primaryInsuranceId?: string | null;
  secondaryInsuranceId?: string | null;
  tertiaryInsuranceId?: string | null;
  procedureFromDate?: string | null;
  procedureToDate?: string | null;
  lastBilledDate?: string | null;
  lastBilledInsurance?: string | null;
  pwkReportTypeCode?: string | null;
  pwkTransmissionCode?: string | null;
  pwkAttachmentNumber?: string | null;
  pendingCommit?: boolean;
  hasActivePaymentPlan?: boolean;
  claimStatus?: string | null;
  primaryInsuranceAuthNumber?: string | null;
  secondaryInsuranceAuthNumber?: string | null;
  tertiaryInsuranceAuthNumber?: string | null;
  estimatedPatientBalance?: number | null;
  collectionsAssignDate?: string | null;
  externalId?: string | null;
  denied?: string | null;
  visitDate?: string | null;
  holdVisit?: boolean;
  pointOfOriginId?: string | null;
  admissionTypeId?: string | null;
  dischargeStatusId?: string | null;
  admitHour?: number | null;
  dischargeHour?: number | null;
  billingNote?: string | null;
  claimNoteType1?: string | null;
  claimNote1?: string | null;
  claimNoteType2?: string | null;
  claimNote2?: string | null;
  claimNoteType3?: string | null;
  claimNote3?: string | null;
  claimNoteType4?: string | null;
  claimNote4?: string | null;
  claimNoteType5?: string | null;
  claimNote5?: string | null;
  claimNoteType6?: string | null;
  claimNote6?: string | null;
  claimNoteType7?: string | null;
  claimNote7?: string | null;
  claimNoteType8?: string | null;
  claimNote8?: string | null;
  claimNoteType9?: string | null;
  claimNote9?: string | null;
  claimNoteType10?: string | null;
  claimNote10?: string | null;
  admittingDiagnosisCodeId?: string | null;
  admittingDiagPresentOnAdmission?: string | null;
  visitReason1DiagnosisCodeId?: string | null;
  visitReason1PresentOnAdmission?: string | null;
  visitReason2DiagnosisCodeId?: string | null;
  visitReason2PresentOnAdmission?: string | null;
  visitReason3DiagnosisCodeId?: string | null;
  visitReason3PresentOnAdmission?: string | null;
  cause1DiagnosisCodeId?: string | null;
  cause1PresentOnAdmission?: string | null;
  cause2DiagnosisCodeId?: string | null;
  cause2PresentOnAdmission?: string | null;
  cause3DiagnosisCodeId?: string | null;
  cause3PresentOnAdmission?: string | null;
  drgDiagnosisCodeId?: string | null;
  drgPresentOnAdmission?: string | null;
  principalProcedureId?: string | null;
  principalProcedureDate?: string | null;
  otherProcedure1Id?: string | null;
  otherProcedure1Date?: string | null;
  otherProcedure2Id?: string | null;
  otherProcedure2Date?: string | null;
  otherProcedure3Id?: string | null;
  otherProcedure3Date?: string | null;
  otherProcedure4Id?: string | null;
  otherProcedure4Date?: string | null;
  otherProcedure5Id?: string | null;
  otherProcedure5Date?: string | null;
  occurrenceSpanCode1Id?: string | null;
  occurrenceSpan1FromDate?: string | null;
  occurrenceSpan1ToDate?: string | null;
  occurrenceSpanCode2Id?: string | null;
  occurrenceSpan2FromDate?: string | null;
  occurrenceSpan2ToDate?: string | null;
  occurrenceCode1Id?: string | null;
  occurrence1Date?: string | null;
  occurrenceCode2Id?: string | null;
  occurrence2Date?: string | null;
  occurrenceCode3Id?: string | null;
  occurrence3Date?: string | null;
  occurrenceCode4Id?: string | null;
  occurrence4Date?: string | null;
  valueCode1Id?: string | null;
  value1Amount?: number | null;
  valueCode2Id?: string | null;
  value2Amount?: number | null;
  valueCode3Id?: string | null;
  value3Amount?: number | null;
  conditionCode1Id?: string | null;
  conditionCode2Id?: string | null;
  conditionCode3Id?: string | null;
  conditionCode4Id?: string | null;
  conditionCode5Id?: string | null;
  conditionCode6Id?: string | null;
  conditionCode7Id?: string | null;
  conditionCode8Id?: string | null;
  conditionCode9Id?: string | null;
  conditionCode10Id?: string | null;
  conditionCode11Id?: string | null;
  admittingDiagnosisCode?: CodeSimpleViewModel;
  visitReason1DiagnosisCode?: CodeSimpleViewModel;
  visitReason2DiagnosisCode?: CodeSimpleViewModel;
  visitReason3DiagnosisCode?: CodeSimpleViewModel;
  cause1DiagnosisCode?: CodeSimpleViewModel;
  cause2DiagnosisCode?: CodeSimpleViewModel;
  cause3DiagnosisCode?: CodeSimpleViewModel;
  drgDiagnosisCode?: CodeSimpleViewModel;
  principalProcedure?: ProcedureSimpleViewModel;
  otherProcedure1?: ProcedureSimpleViewModel;
  otherProcedure2?: ProcedureSimpleViewModel;
  otherProcedure3?: ProcedureSimpleViewModel;
  otherProcedure4?: ProcedureSimpleViewModel;
  otherProcedure5?: ProcedureSimpleViewModel;
  occurrenceSpanCode1?: CodeSimpleViewModel;
  occurrenceSpanCode2?: CodeSimpleViewModel;
  occurrenceCode1?: CodeSimpleViewModel;
  occurrenceCode2?: CodeSimpleViewModel;
  occurrenceCode3?: CodeSimpleViewModel;
  occurrenceCode4?: CodeSimpleViewModel;
  valueCode1?: CodeSimpleViewModel;
  valueCode2?: CodeSimpleViewModel;
  valueCode3?: CodeSimpleViewModel;
  conditionCode1?: CodeSimpleViewModel;
  conditionCode2?: CodeSimpleViewModel;
  conditionCode3?: CodeSimpleViewModel;
  conditionCode4?: CodeSimpleViewModel;
  conditionCode5?: CodeSimpleViewModel;
  conditionCode6?: CodeSimpleViewModel;
  conditionCode7?: CodeSimpleViewModel;
  conditionCode8?: CodeSimpleViewModel;
  conditionCode9?: CodeSimpleViewModel;
  conditionCode10?: CodeSimpleViewModel;
  conditionCode11?: CodeSimpleViewModel;
  pointOfOrigin?: CodeSimpleViewModel;
  admissionType?: CodeSimpleViewModel;
  dischargeStatus?: CodeSimpleViewModel;
  readonly claimNoteType1Display?: string | null;
  readonly claimNoteType2Display?: string | null;
  readonly claimNoteType3Display?: string | null;
  readonly claimNoteType4Display?: string | null;
  readonly claimNoteType5Display?: string | null;
  readonly claimNoteType6Display?: string | null;
  readonly claimNoteType7Display?: string | null;
  readonly claimNoteType8Display?: string | null;
  readonly claimNoteType9Display?: string | null;
  readonly claimNoteType10Display?: string | null;
  attendingProviderId?: string | null;
  referringProviderId?: string | null;
  supervisingProviderId?: string | null;
  locationId?: string | null;
  diagnosis1Id?: string | null;
  diagnosis1PresentOnAdmission?: string | null;
  diagnosis2Id?: string | null;
  diagnosis2PresentOnAdmission?: string | null;
  diagnosis3Id?: string | null;
  diagnosis3PresentOnAdmission?: string | null;
  diagnosis4Id?: string | null;
  diagnosis4PresentOnAdmission?: string | null;
  diagnosis5Id?: string | null;
  diagnosis5PresentOnAdmission?: string | null;
  diagnosis6Id?: string | null;
  diagnosis6PresentOnAdmission?: string | null;
  diagnosis7Id?: string | null;
  diagnosis7PresentOnAdmission?: string | null;
  diagnosis8Id?: string | null;
  diagnosis8PresentOnAdmission?: string | null;
  diagnosis9Id?: string | null;
  diagnosis9PresentOnAdmission?: string | null;
  diagnosis10Id?: string | null;
  diagnosis10PresentOnAdmission?: string | null;
  diagnosis11Id?: string | null;
  diagnosis11PresentOnAdmission?: string | null;
  diagnosis12Id?: string | null;
  diagnosis12PresentOnAdmission?: string | null;
  diagnosis1?: CodeSimpleViewModel;
  diagnosis2?: CodeSimpleViewModel;
  diagnosis3?: CodeSimpleViewModel;
  diagnosis4?: CodeSimpleViewModel;
  diagnosis5?: CodeSimpleViewModel;
  diagnosis6?: CodeSimpleViewModel;
  diagnosis7?: CodeSimpleViewModel;
  diagnosis8?: CodeSimpleViewModel;
  diagnosis9?: CodeSimpleViewModel;
  diagnosis10?: CodeSimpleViewModel;
  diagnosis11?: CodeSimpleViewModel;
  diagnosis12?: CodeSimpleViewModel;
  primaryProvider?: ProviderViewModel;
  attendingProvider?: ProviderViewModel;
  referringProvider?: ProviderViewModel;
  supervisingProvider?: ProviderViewModel;
  placeOfServiceCode?: CodeViewModel;
  location?: LocationDetailsViewModel;
  primaryInsurance?: InsuranceDetailsViewModel;
  secondaryInsurance?: InsuranceDetailsViewModel;
  tertiaryInsurance?: InsuranceDetailsViewModel;
  procedureTransactions?: Array<ProcedureTransactionDetailsViewModel> | null;
  arTransactions?: Array<ARTransactionDetailsViewModel> | null;
  eobCodes?: Array<EobHistoryViewModel> | null;
  pendingBatchTransactions?: Array<PendingBatchTransactionViewModel> | null;
}
